export default {
  index: '首頁',
  logOut: '退出登錄',
  profile: '個人中心',
  webcomeBack: '歡迎回來',
  noName: '暫無名稱'
};
